import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import i18n from './plugins/i18n'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Vant from 'vant';
import 'vant/lib/index.css'

Vue.config.productionTip = false



Vue.use(Vant);

new Vue({
  router,
  i18n,
  BootstrapVue,
  IconsPlugin,
  render: h => h(App),
}).$mount('#app')
